import React from 'react';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import Button from 'common/Button';

import 'styles/common/confirmation-modal.scss';

const L = logger('PopupModal');

const PopupModal = ({ tag: tagFromProps, buttonCallback, buttonText, children, popupMessage, popupTitle }) => {
  const tag = fromAnyToTrimmed(tagFromProps);

  if (typeof popupMessage !== 'string') L.warn('()', 'Not a string, popupMessage:', popupMessage);

  return (
    <div data-bem="PopupModal--src-common" data-tag={tag}>
      <div data-bem="PopupModal__overlay" className="overlay" />
      <div data-bem="PopupModal__dialog" className="confirmation-modal animated zoomIn">
        <div data-bem="PopupModal__wrapper" className="modal-body">
          <h2 data-bem="PopupModal__title" className="modal-title">
            {popupTitle}
          </h2>
          <div data-bem="PopupModal__body" className="modal-content">
            {children}
            {fromAnyToString(popupMessage)
              .split('<br/>')
              .map((text, index) => (
                <p key={createNodeKey({ index })}>{text}</p>
              ))}
          </div>
          <div data-bem="PopupModal__footer" className="modal-footer">
            <Button buttonName={buttonText} onClickButton={buttonCallback} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;
